import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { companyLogo, searchIcon, cartIcon, profileIcon } from '../../resources/images';
import * as UserActions from '../../actions/userAction';

class NavigationBar extends Component {

    constructor(props) {
        super(props);
        this.toogleProfile = this.toogleProfile.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.state = {
            showProfile: false
        }
    }

    toogleProfile = () => {
        if (!this.state.showProfile) {
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }
        this.setState(prevState => ({
            showProfile: !prevState.showProfile
        }))
    }

    handleOutsideClick(e) {
        if (!!this.profileBtn && !this.profileBtn.contains(e.target)) {
            this.toogleProfile();
        }
    }


    handleNavigate = (path) => {
        if (this.props.location.pathname !== path) this.props.history.push(path)
    }

    render() {
        const { pathname } = this.props.location
        const cartItemCount = this.props.ProductStore.productList.length
        const loggedIn = !!this.props.UserStore.userInfo.email
        const { showProfile } = this.state
        return (
            <div className="navBar">
                <img src={companyLogo} alt="Company Logo" className="qbLogo" onClick={() => this.handleNavigate('/')} />
                <div className="actionCont">
                    <div className="navCont">
                        <div className="itemCont">
                            <div className={pathname === '/' ? "fLabel active" : "fLabel"} onClick={() => this.handleNavigate('/')}>Landing</div>
                        </div>
                        <div className="itemCont">
                            <div className={pathname === '/contact-us' ? "fLabel active" : "fLabel"}>Contact Us</div>
                        </div>
                    </div>
                    <div className="userCont">
                        {!loggedIn &&
                            <div className="fLabel" onClick={() => this.handleNavigate('/login')}>LOGIN</div>
                        }
                        {loggedIn &&
                            <div className="iconCont">
                                <img src={profileIcon} alt="Profile Icon" className="qbIcon" style={{ margin: 0 }} onClick={() => this.toogleProfile()} ref={node => this.profileBtn = node} />
                                {showProfile &&
                                    <div className="profileBox animated fadeIn">
                                        <div className="itemCont" onClick={() => this.handleNavigate('/profile')}>My Profile</div>
                                        <div className="itemCont" onClick={() => this.handleNavigate('/resources')}>Resources</div>
                                        <div className="itemCont logout" onClick={() => this.props.logout()}>Logout</div>
                                    </div>
                                }
                            </div>
                        }
                        <img src={searchIcon} alt="Search Icon" className="qbIcon" />
                        <div className="iconCont" onClick={() => this.props.history.push('/cart')}>
                            <img src={cartIcon} alt="Cart Icon" className="qbIcon" style={{ margin: 0 }} />
                            {cartItemCount >= 1 &&
                                <div className="notiBubble animated zoomIn">{cartItemCount}</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ UserStore, ProductStore, UiStore }) => ({
    UserStore,
    ProductStore,
    currNavTab: UiStore.currNavTab,
});

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(UserActions.logout())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavigationBar));


// WEBPACK FOOTER //
// ./src/Components/misc/NavigationBar.js